const TRACK_DISABLED = 'false';
const TRACK_MAP = 'map_interaction';

class GtmTracker {
    constructor() {
        this.handler = null;
    }

    init() {
        this.handler = this.handleClick.bind(this);
        document.addEventListener('click', this.handler, { passive: true });
    }


    handleClick(e) {
        const target = e.target.closest('button, a, [data-track]');
        if (!target) return;

        if (target.dataset.track === TRACK_DISABLED) return;

        let classes = '';
        if (typeof target.className === 'string') {
            classes = target.className;
        } else if (target.className && typeof target.className.baseVal === 'string') {
            classes = target.className.baseVal;
        }

        let text = target.innerText?.trim().slice(0, 100)
            || target.getAttribute('aria-label')
            || target.getAttribute('title')
            || null;


        if (target.dataset.track === TRACK_MAP) {
            text = 'Map Click';
        }

        const clickPayload = {
            type: target.tagName.toLowerCase(),
            text: text,
            href: target.getAttribute('href') || null,
            target: target.getAttribute('target') || null,
            id: target.id || null,
            classes: classes || null,
            track: target.dataset.track || null,
            category: target.dataset.trackCategory || null,
            label: target.dataset.trackLabel || null,
            page: window.location.pathname,
            page_title: document.title,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ click: undefined });
        window.dataLayer.push({ event: 'auto_click', click: clickPayload });
    }

    destroy() {
        if (this.handler) {
            document.removeEventListener('click', this.handler);
            this.handler = null;
        }
    }
}

export default GtmTracker;